import {IDefaultService} from '../iDefault.service';
import {Observable} from 'rxjs';
import {DtoModel} from '../../../../../common/entity/dto/dto.model';
import {Payload} from '../../../payload/payload';
import {PayloadV2} from '../../../payload/payloadV2';
import {HttpContext, HttpHeaders, HttpParams} from '@angular/common/http';
import {EntityCollectionServiceBase} from '@ngrx/data';

export abstract class AbstractSaveOneService<Entity extends DtoModel, P extends Payload> extends IDefaultService<Entity, Entity> {

    isUpdateAllowed(): boolean {
        return true;
    }

    isCreateAllowed(): boolean {
        return true;
    }

    save(payload: P): Promise<Entity> {
        this.setLoading(true);
        this.setError(undefined);

        console.log(['payload', payload]);
        let observable: Observable<Entity>;
        let id;
        if (payload instanceof PayloadV2) {
            id = (payload as PayloadV2).id;
        } else if (payload['id'] !== undefined) {
            id = payload['id'];
        } else {
            id = this.repository.selectId(payload as any);
        }
        console.log(['saveId', id, payload]);

        const body = this.buildBody(payload);
        console.log(['body', body]);
        if (id) {
            observable = this.dataService.executeUpdate(id, body);
        } else {
            observable = this.dataService.executeCreate(body);
        }

        return new Promise<Entity>((resolve, reject) => {
            observable.toPromise()
                .then((entity) => {
                    // console.log(['result entity', entity]);
                    /* const convertedEntity = this.dataService.buildStoredEntityEntity(entity);
                    console.log(['converted entity', convertedEntity]); */
                    if (id) {
                        // this.repository.updateOneInCache(convertedEntity);
                        this.repository.updated(entity);
                    } else {
                        // this.repository.addOneToCache(convertedEntity);
                        this.repository.created(entity);
                    }
                    this.getRepositoriesToSynchronize().forEach(value => value.clearCache());
                    this.postSave(entity);
                    resolve(entity);
                })
                .catch((e) => {
                    this.setError(e);
                    reject(e);
                })
                .finally(() => this.setLoading(false));
        });
    }

    buildEntityFromStoreEntity(storedEntity: Entity): Entity {
        return storedEntity;
    }

    buildStoredEntityEntity(entity: Entity): Entity {
        return entity;
    }

    isDtoSummary(): boolean {
        return false;
    }

    protected postSave(entity: Entity): void {

    }

    protected buildBody(payload: P): any {
        return payload;
    }

    buildOptions(payload: P): {
        headers?: HttpHeaders | {
            [header: string]: string | string[];
        };
        context?: HttpContext;
        observe?: 'body';
        params?: HttpParams | {
            [param: string]: string | number | boolean | ReadonlyArray<string | number | boolean>;
        };
        reportProgress?: boolean;
        responseType?: 'json';
        withCredentials?: boolean;
    } {
        return undefined;
    }

    protected getRepositoriesToSynchronize(): EntityCollectionServiceBase<any>[] {
        return [];
    }
}
